import { memo } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import Image from "../../../../Elements/Image/Image";
import Button from "../../../../Elements/Button/Button";
import { LinkToNewTab } from "../../../../Elements/Link/Link";

import styles from "./styles.module.scss";

const PRODUCTS = ["picker", "forms", "pay"];

const ExploreProductsSection = memo(() => {
  const { getTextByKey, getHtmlByKey } = useContent();

  return (
    <div className={styles.productsWrapper}>
      <h2>{getTextByKey("explore-products-title")}</h2>
      <ul>
        {PRODUCTS.map((product) => (
          <li key={product}>
            <Image
              name={`features/${product}_logo`}
              ext="svg"
              className={styles.productImage}
            />
            <h3 className={styles.title}>{getTextByKey(product + "-title")}</h3>
            <p className={styles.description}>
              {getHtmlByKey(product + "-description")}
            </p>
            {/*@ts-ignore*/}
            <LinkToNewTab page={`jumbo-${product}`}>
              <Button className={styles.learnMoreButton}>
                {getTextByKey("learn-more")}
              </Button>
            </LinkToNewTab>
          </li>
        ))}
      </ul>
    </div>
  );
});

export default ExploreProductsSection;
